import { TextColorType } from '@repo/ui';
import { userValueFormat } from 'helpers/userValueFormat';
import { InsightMetric } from 'types/Insights';

// category_key value for the Gut resilience score metric (as stored in the DB).
export const RESILIENCE_CATEGORY_KEY = 'Gut resilience score';

// evaluation_color → headline label + text color for the resilience card.
const RESILIENCE_LABELS: Record<string, { label: string; color: TextColorType }> =
  {
    red: { label: 'Low resilience', color: 'red' },
    orange: { label: 'Borderline resilience', color: 'orange' },
    grey: { label: 'Typical resilience', color: 'grey' },
    green: { label: 'High resilience', color: 'green' },
  };

export type ResilienceResultConfig = {
  label: string;
  color: TextColorType;
  scoreText: string;
};

// Returns the resilience-specific headline/subtitle config, or null if the
// metric isn't the Gut resilience score.
export function getResilienceResultConfig(
  metric: Partial<InsightMetric>,
): ResilienceResultConfig | null {
  if (metric.category_key !== RESILIENCE_CATEGORY_KEY) return null;

  const { label, color } = RESILIENCE_LABELS[metric.evaluation_color ?? ''] ?? {
    label: 'Resilience',
    color: 'dark',
  };

  const scoreText = `Your score: ${userValueFormat(
    metric.user_value ?? 0,
    metric.data_type ?? 'number',
    metric.user_string ?? '',
  )}`;

  return { label, color, scoreText };
}
